export default "__VITE_ASSET__BNX7$IWw__"